import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Swal from "sweetalert2";
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import { useNavigate } from 'react-router-dom';
import Toggle from 'react-toggle';

function Bill({ selectedInvoice, setSelectedInvoice }) {
    const getTodayDate = () => {
        const today = new Date();
        return today;
    };
    const navigate = useNavigate();
    const parseDDMMYYYY = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const [toggleActive, setToggleActive] = useState(false);
    const [getCustomer, setGetCustomer] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editInvoice, setEditInvoice] = useState(false);
    const [invoiceData, setGetInvoiceData] = useState({});
    const [formData, setFormData] = useState({

        invDate: getTodayDate(),
        invDueDate: getTodayDate(),
        Client_Code: "",
        InvoiceNo: "",
        Branch_Code: "",
    });

    const [invoiceSubmittedData, setInvoiceSubmittedData] = useState([]);
    const [invoice, setInvoice] = useState({
        ItemDescription: "", QTY: 0, Rate: 0, Amount: 0
    });

    useEffect(() => {
        if (!selectedInvoice) return;

        // 1️⃣ set docket in form
        setFormData(prev => ({
            ...prev,
            InvoiceNo: selectedInvoice,
        }));

        // 2️⃣ force toggle ON (from Performa)
        setToggleActive(true);

        // 3️⃣ auto search (no Swal)
        handleSearch(selectedInvoice);

        // 4️⃣ clear
        setSelectedInvoice(null);

    }, [selectedInvoice]);

    useEffect(() => {
        console.log(invoiceSubmittedData);
    }, [invoiceSubmittedData])
    useEffect(() => {
        console.log(formData);
    }, [formData])
    const handleInvoiceChange = (e) => {
        const { name, value } = e.target;
        setInvoice((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    useEffect(() => {
        setInvoice((prev) => ({
            ...prev,
            Amount: invoice.QTY * invoice.Rate,


        }))
    }, [invoice.QTY, invoice.Rate])

    useEffect(() => {
        const loginData = JSON.parse(localStorage.getItem("Login"));

        console.log("Login Data:", loginData);

        const code = loginData?.Customer_Code;

        console.log("Customer Code:", code);
        console.log("Customer Data Array:", getCustomer);

        if (code && getCustomer.length > 0) {

            const found = getCustomer.find(
                c => String(c.Customer_Code) === String(code)
            );

            console.log("Found customer data:", found);

            if (found) {
                setFormData((prev) => ({
                    ...prev,
                    Client_Code: code,
                    Branch_Code: found.Branch_Code
                }));
            }
        }
    }, [getCustomer]);

    useEffect(() => {


        const code = formData?.Client_Code;
        if (code && getCustomer.length > 0) {

            const found = getCustomer.find(
                c => String(c.Customer_Code) === String(code)
            );

            console.log("Found customer data:", found);

            if (found) {
                setFormData((prev) => ({
                    ...prev,
                    Branch_Code: found.Branch_Code
                }));
            }
        }
    }, [formData.Client_Code]);
    const handleAddRow = (e) => {
        e.preventDefault();

        if (!invoice.ItemDescription) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill atleast one item.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null) {
            // update existing row
            const updated = [...invoiceSubmittedData];
            updated[editIndex] = invoice;
            setInvoiceSubmittedData(updated);
            setEditIndex(null);
        } else {
            // add new row
            setInvoiceSubmittedData((prev) => [...prev, invoice]);
        }
        setInvoice({
            ItemDescription: "", QTY: 0, Rate: 0, Amount: 0
        });
    };
    const resetAllForm = () => {
        setFormData({
            invDate: getTodayDate(),
            invDueDate: getTodayDate(),
            Client_Code: "",
            InvoiceNo: "",
            Branch_Code: ""
        });
        setInvoice({
            ItemDescription: "", QTY: 0, Rate: 0, Amount: 0
        });
        setInvoiceSubmittedData([]);
        setEditIndex(null);
        setEditInvoice(false)
    }
    const formatDate = (date) => {
        if (!date) return null;
        return new Date(date).toLocaleDateString("en-CA");
    };


    const handleSearch = async (InvoiceNo) => {
        try {
            const response = await getApi(
                `/GetFutureInvoiceById?InvoiceNo=${InvoiceNo}`
            );

            if (response.status === 1 && response.data) {
                const data = response.data;
                setEditInvoice(true);

                setFormData((prev) => ({
                    ...prev,
                    InvoiceNo: data.InvoiceNo,
                    Client_Code: data.CustomerCode,
                    invDate: parseDDMMYYYY(data.InvoiceDate),
                    invDueDate: parseDDMMYYYY(data.DueDate),
                }));

                setInvoiceSubmittedData(
                    (data.Items || []).map((item) => ({
                        InvoiceDetailId: item.InvoiceDetailId,
                        ItemDescription: item.ItemDescription,
                        QTY: item.Qty,
                        Rate: item.Rate,
                        Amount: item.Amount,
                    }))
                );

                return true;
            }

            Swal.fire({
                icon: "error",
                title: "Invoice Not Found",
            });

            setEditInvoice(false);
            return false;
        } catch (err) {
            console.error(err);
            setEditInvoice(false)

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to fetch invoice.",
            });

            return false;
        }
    };




    const handleSave = async (e) => {
        e.preventDefault();

        if (!formData.Client_Code) {
            return Swal.fire({
                icon: "warning",
                title: "Missing Field",
                text: "Please select Customer.",
            });
        }

        if (invoiceSubmittedData.length < 1) {
            return Swal.fire({
                icon: "warning",
                title: "Empty Items",
                text: "Please add at least one item.",
            });
        }

        try {
            const payload = {
                CustomerCode: formData?.Client_Code,
                LocationCode: formData?.Branch_Code,
                InvoiceDate: formData.invDate ? formData.invDate.toISOString().split("T")[0]
                    : "",
                DueDate: formData.invDueDate ? formData.invDueDate.toISOString().split("T")[0]
                    : "",
                Remark1: formData.Remark1 || "",
                Remark2: formData.Remark2 || "",
                Remark3: formData.Remark3 || "",
                Items: invoiceSubmittedData.map((item) => ({
                    ItemDescription: item.ItemDescription,
                    Qty: Number(item.QTY),
                    Rate: Number(item.Rate),
                    Amount: Number(item.Amount),
                })),
            };

            console.log(payload);

            const response = await postApi("/AddFutureInvoice", payload);

            if (response.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Saved",
                    html: `
                    Future Invoice Saved Successfully.<br/>
                    <b>Invoice No : ${response.InvoiceNo}</b>
                `,
                });

                resetAllForm();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: response.message || "Error saving invoice.",
                });
            }
        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: err.message,
            });
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!formData.InvoiceNo) {
            return Swal.fire({
                icon: "warning",
                title: "Missing Invoice",
                text: "Invoice No is required.",
            });
        }

        if (!formData.Client_Code) {
            return Swal.fire({
                icon: "warning",
                title: "Missing Field",
                text: "Please select Customer.",
            });
        }

        if (invoiceSubmittedData.length < 1) {
            return Swal.fire({
                icon: "warning",
                title: "Empty Items",
                text: "Please add at least one item.",
            });
        }

        try {
            const payload = {
                InvoiceNo: formData.InvoiceNo,
                CustomerCode: formData.Client_Code,
                LocationCode: formData.Branch_Code,
                InvoiceDate: formData.invDate
                    ? formData.invDate.toISOString().split("T")[0]
                    : "",
                DueDate: formData.invDueDate
                    ? formData.invDueDate.toISOString().split("T")[0]
                    : "",
                Remark1: formData.Remark1 || "",
                Remark2: formData.Remark2 || "",
                Remark3: formData.Remark3 || "",
                Items: invoiceSubmittedData.map((item) => ({
                    InvoiceDetailId: item.InvoiceDetailId || 0, // Existing item id
                    ItemDescription: item.ItemDescription,
                    Qty: Number(item.QTY),
                    Rate: Number(item.Rate),
                    Amount: Number(item.Amount),
                })),
            };

            console.log(payload);

            const response = await postApi("/UpdateFutureInvoice", payload);

            if (response.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Updated",
                    text: "Future Invoice Updated Successfully.",
                });
                resetAllForm();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: response.message || "Error updating invoice.",
                });
            }
        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: err.message,
            });
        }
    };

    const fetchCustomerData = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("Login"));
            const response = await getApi(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}&Customer_Code=${user?.Customer_Code}`)
            setGetCustomer(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchCustomerData();
    }, [])
    return (
        <>
            <style>
                {`
  .table .tr-input td, th {
    padding: 3px !important;
  }
    .table td input{
    height:36px
    }
    .table-container {
    width: 100%;
    overflow-x: hidden;
}

.table-container .table {
    width: 100%;
    min-width: 100%;
}

@media (max-width:768px) {
    .table-container {
        overflow-x: auto;
    }

    .table-container .table {
        min-width: 800px;
    }
}
`}

            </style>

            <div className="body">
                <div className="container1">





                    <form className="m-0 px-2 py-2" style={{overflowY:"hidden"}}>
                        <div className="row g-3 mx-0">

                            {/* Invoice Date */}
                            <div className="input-field col-12 col-sm-12 col-md-6 col-lg-3">
                                <label className="form-label">Invoice No</label>
                                <div className="docket-wrapper" style={{ flex: 1 }}>
                                    <input
                                        value={formData.InvoiceNo}
                                        className="input"
                                        placeholder={toggleActive ? "Enter Invoice No" : "Auto"}
                                        disabled={!toggleActive}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                InvoiceNo: e.target.value,
                                            })
                                        }
                                        onKeyDown={async (e) => {
                                            if (e.key === "Enter" || e.key === "Tab") {
                                                e.preventDefault(); // Stop default action first

                                                const found = await handleSearch(formData.InvoiceNo);

                                                if (found) {
                                                    // Move to next input
                                                    const form = e.target.form;
                                                    if (form) {
                                                        const index = [...form.elements].indexOf(e.target);
                                                        if (form.elements[index + 1]) {
                                                            form.elements[index + 1].focus();
                                                        }
                                                    }
                                                }
                                                // If not found, focus remains here
                                            }
                                        }}
                                    />



                                    <Toggle className="react-toggle"
                                        checked={toggleActive}
                                        onChange={() => setToggleActive(prev => !prev)}
                                        tabIndex={-1}
                                    />
                                </div>


                            </div>

                            <div className="input-field col-12 col-sm-12 col-md-6 col-lg-4">
                                <label className="form-label">Customer Name</label>
                                <Select
                                    className="blue-selectbooking"
                                    classNamePrefix="blue-selectbooking"
                                    options={getCustomer
                                        .map(cust => ({
                                            label: cust.Customer_Name,
                                            value: cust.Customer_Code,
                                        }))
                                    }
                                    value={
                                        formData.Client_Code
                                            ? {
                                                value: formData.Client_Code,
                                                label: getCustomer.find(
                                                    cust => cust.Customer_Code === formData.Client_Code
                                                )?.Customer_Name || ""
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        setFormData({
                                            ...formData,
                                            Client_Code: selectedOption ? selectedOption.value : ""
                                        });
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>


                            {/* Invoice Date */}
                            <div className="input-field col-12 col-sm-12 col-md-6 col-lg-2">
                                <label className="form-label">Invoice Date</label>
                                <DatePicker
                                    portalId="rootPortal"
                                    selected={formData.invDate}
                                    onChange={(date) => setFormData({ ...formData, invDate: date })}
                                    dateFormat="dd/MM/yyyy"

                                />
                            </div>

                            {/* Due Date */}
                            <div className="input-field col-12 col-sm-12 col-md-6 col-lg-2">
                                <label className="form-label">Due Date</label>
                                <DatePicker
                                    portalId="rootPortal"
                                    selected={formData.invDueDate}
                                    onChange={(date) => setFormData({ ...formData, invDueDate: date })}
                                    dateFormat="dd/MM/yyyy"

                                />
                            </div>










                        </div>
                    </form>




                    <div className='table-container'>
                        <table className='table table-bordered table-sm'>
                            <thead className='table-info table-sm'>
                                <tr>
                                    <th scope="col">Desciption Of Goods</th>
                                    <th scope="col" className='w-100'>QTY</th>
                                    <th scope="col" className='w-100'>Rate</th>
                                    <th scope="col" className='w-100'>Total Amount</th>
                                    <th scope="col" className='w-60'>Action</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                <tr className='tr-input'>
                                    <td >
                                        <input className="input" type="text" placeholder="Items" name='ItemDescription'
                                            style={{ textAlign: "start", paddingLeft: "20px" }} value={invoice.ItemDescription}
                                            onChange={handleInvoiceChange} />
                                    </td>

                                    <td>
                                        <input className="input" type="tel" placeholder="QTY" name="QTY"
                                            style={{ textAlign: "center" }} value={invoice.QTY}
                                            onChange={handleInvoiceChange} />
                                    </td>
                                    <td>
                                        <input className="input" type="tel" placeholder="Rate" name="Rate"
                                            style={{ textAlign: "center" }} value={invoice.Rate}
                                            onChange={handleInvoiceChange} />
                                    </td>
                                    <td>
                                        <input className="input" type="tel" placeholder="TOTAL" name="Amount"
                                            style={{ textAlign: "center" }} value={invoice.Amount}
                                            onChange={handleInvoiceChange} />
                                    </td>
                                    <td>
                                        <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3.2px", paddingTop: "2px", fontSize: "30px" }}
                                            onClick={handleAddRow}>
                                            <i className="bi bi-plus"></i>
                                        </button>
                                    </td>
                                </tr>
                                {Array.isArray(invoiceSubmittedData) && invoiceSubmittedData.map((data, index) => (
                                    <tr key={index}>

                                        <td>{data.ItemDescription}</td>

                                        <td>{data.QTY}</td>
                                        <td>{data.Rate}</td>
                                        <td >{data.Amount}</td>
                                        <td className='w-60'>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                <button className='edit-btn'
                                                    onClick={() => {
                                                        setInvoice({
                                                            ItemDescription: data.ItemDescription,
                                                            QTY: data.QTY,
                                                            Rate: data.Rate,
                                                            Amount: data.Amount,
                                                        });
                                                        setEditIndex(index);
                                                    }}>
                                                    <i className='bi bi-pen'></i>
                                                </button>
                                                <button onClick={() => {
                                                    setInvoiceSubmittedData(invoiceSubmittedData.filter((_, ind) => ind !== index));
                                                    setEditIndex(null);
                                                    setInvoice({ ItemDescription: "", QTY: 0, Rate: 0, Amount: 0 });
                                                }}
                                                    className='edit-btn'><i className='bi bi-trash'></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>


                    {/* <div className="pagination">
                        <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                            {'<'}
                        </button>
                        <span style={{ color: "#333", padding: "5px" }}>Page {currentPage} of {totalPages}</span>
                        <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                            {'>'}
                        </button>
                    </div> */}

                    <div className="bottom-buttons" style={{ display: "flex", flexWrap: "wrap" }}>
                        {!editInvoice ? <button className='ok-btn' onClick={handleSave}>Save</button> :
                            <button className='ok-btn' onClick={handleUpdate}>Update</button>}
                        <button className='ok-btn' onClick={resetAllForm}>Cancel</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Bill;